const log = (...args: any) =>
  window.DH_DEBUG === true &&
  // eslint-disable-next-line no-console
  console.log(
    `%c[BNDL - Umbrella widget]`,
    `color: #1E2647; font-weight: bold;`,
    ...args,
  );

export default log;
